import { InfoCard } from '@innovyze/stylovyze';
import { useStyle } from './FieldInspectionSummary.styles';
import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

export const FieldInspectionSummary = () => {
	const { t } = useGlobalization();
	const classes = useStyle();

	return (
		<InfoCard
			title={t('Field Inspection Summary')}
			className={classes.root}>
			<img
				alt="summary"
				src={require('./summary.png')}
				// style={{ maxHeight: '202px', maxWidth: '200' }}
			/>
		</InfoCard>
	);
};
